<template>
  <div>
    <div v-if="open">
      <div class="modalCustom modalCustom__center">
        <component
          :is="this.componentName"
          @close="closeModal"
          @submit="submit($event)"
          :data="data"
          @deleted="deleted($event)"
        >
        </component>
      </div>
      <div v-if="open && displayDarkBg" class="darkBg"></div>
    </div>
  </div>
</template>

<script>
import PasswordModal from './PasswordModal';
import DeleteModal from './DeleteModal';
import DeleteButton from '../buttons/DeleteButton';
import CreateNewButton from '../buttons/CreateNewButton';
import ResetButton from '../buttons/ResetButton';
import CreateCredentialModal from './CreateCredentialModal';
import CreateUserModal from './CreateUserModal';
import CreateRoleModal from './CreateRoleModal';
import AddRoleModal from './AddRoleModal';
import AddUserModal from './AddUserModal';
import AddScopesModal from './AddScopesModal';
import CreateCompanyModal from './CreateCompanyModal';
import scopesChecker from '../../router/scopes/scopesChecker';
import FiltersModal from './FiltersModal';
import AssignCertificateModal from './AssignCertificateModal';
import CreateCertificateModal from './CreateCertificateModal';
import EditCertificateModal from './EditCertificateModal';
import ConsumptionFileUploadFormModal from '@/components/consumption/ConsumptionFileUploadFormModal';
import GenerateTokenModal from '@/components/Application/GenerateTokenModal';
import GreenButtonDataImportModal from '@/components/consumption/GreenButtonDataImportModal';
export default {
  name: 'ModalTemplate',
  components: {
    AssignCertificateModal,
    DeleteModal,
    FiltersModal,
    PasswordModal,
    DeleteButton,
    CreateNewButton,
    ResetButton,
    CreateCredentialModal,
    CreateUserModal,
    CreateRoleModal,
    AddRoleModal,
    AddUserModal,
    AddScopesModal,
    CreateCompanyModal,
    CreateCertificateModal,
    EditCertificateModal,
    ConsumptionFileUploadFormModal,
    GenerateTokenModal,
    GreenButtonDataImportModal,
  },
  props: {
    action: {
      type: String,
      default: null,
    },
    clicked: {
      type: Boolean,
      default: false,
    },
    componentName: {
      type: String,
    },
    buttonComponentName: {
      type: String,
      default: null,
    },
    data: {
      type: Object,
    },
    button_data: {
      type: Object,
      default: null,
    },
    displayDarkBg: {
      type: Boolean,
      default: true,
    },
  },
  data: function () {
    return {
      open: false,
    };
  },
  watch: {
    clicked() {
      this.open = this.clicked;
    },
  },
  methods: {
    checkScopes: function () {
      return scopesChecker(this.buttonComponentName, this.$route.name, this.action);
    },
    openButtonClicked: function () {
      this.open = true;
      this.$emit('openButtonClicked');
    },
    closeModal: function () {
      this.open = false;
      this.$emit('update:field', this.open);
      this.$emit('close');
    },
    submit: function (event) {
      this.$emit('submit', event);
    },
    deleted: function (event) {
      this.$emit('deleted', event);
    },
  },
};
</script>

<style scoped></style>
